var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m42.63638,10.66666l-9.13637,0l0,-8.72727c0,-1.06666 -0.91364,-1.93939 -2.03032,-1.93939l-29.43938,0c-1.11667,0 -2.03031,0.87273 -2.03031,1.93939l0,28.12122c0,1.06663 0.91364,1.93935 2.03031,1.93935l9.13639,0l0,8.72727c0,1.06669 0.91364,1.93941 2.03026,1.93941l29.43942,0c1.11669,0 2.03032,-0.87273 2.03032,-1.93941l0,-28.12117c0,-1.06669 -0.91364,-1.93941 -2.03032,-1.93941zm-38.57576,17.45454l0,-24.24241l25.37881,0l0,6.78787l-16.24247,0c-1.11662,0 -2.03026,0.87273 -2.03026,1.93941l0,15.51513l-7.10608,0zm36.54544,10.66669l-25.37877,0l0,-6.78792l16.24241,0c1.11669,0 2.03032,-0.87273 2.03032,-1.93935l0,-15.51519l7.10604,0c0,8.08082 0,16.16164 0,24.24246z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/template.1d00718539c6b44bac730ed995415968.svg";
export { ForwardRef as ReactComponent };